module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "location"
  }, [(_vm.serviceLongitude) ? _c('div', [_c('el-amap', {
    attrs: {
      "vid": "container",
      "zoom": _vm.zoom,
      "center": _vm.center
    }
  }, [_c('el-amap-marker')], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aroundText",
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-img"
  }, [_c('img', {
    staticStyle: {
      "height": "1.2rem"
    },
    attrs: {
      "src": require("../assets/image/bottom.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a934526a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/location.vue
// module id = 237
// module chunks = 1